import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import { Route, Routes } from "react-router-dom";
import "../../../index.css";

import {
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Drawer,
  Divider,
  ListItemText
} from "@mui/material";

import { Menu as MenuIcon } from "@mui/icons-material";
import Notifications from "@mui/icons-material/Notifications";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import Settings from "@mui/icons-material/Settings";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";

import Navigation from "../Navigation/Navigation";

import Home from "../components/Home";
import Kiosks from "../components/Kiosks";
import KioskV2 from "../components/KiosksV2";
import APIKeys from "../components/APIKeys/APIKeys";
import ErrorLogs from "../components/ErrorLogs";
import BagtagLogs from "../components/BagtagLogs";
import ActivityLogs from "../components/ActivityLogs";
// import SocketMonitor from "../../components/Home/SocketMonitor";
import SocketMonitorAPI from "../components/SocketMonitorAPI";
import Users from "../components/Users";
import ServerSettings from "../components/ServerSettings";
import KioskTheme from "../components/KioskTheme";
import Configuration from "../components/Configuration";
import AdsSettings from "../components/AdsSettings";
import Charities from "../components/Charities";

import HttpContext from "../../../contexts/HTTP/HttpContext";
import MobileContext from "../../../contexts/Mobile/MobileContext";

import { useTheme } from "@mui/material/styles";

//const { HARDCODED_VALUES } = require("./../../../constants.js");

let env = require("../../../env.js");

function Dashboard() {
  const theme = useTheme();
  const { get } = useContext(HttpContext);
  const { isMobile } = useContext(MobileContext);

  const [showNavigation, setShowNavigation] = useState(!isMobile);

  const [accountMenuAnchor, setAccountMenuAnchor] = useState(null);
  const [notificationsMenuAnchor, setNotificationsMenuAnchor] = useState(null);

  const [notifications, setNotifications] = useState([]);

  const [appTitle, setAppTitle] = useState("");
  const [adminHeaderColor, setAdminHeaderColor] = useState("");

  console.log("[DEBUG] Dashboard");

  const loadFromAdminTheme = async () => {
    const res = await get("/kiosk/getAdminTheme");

    if (res.status == 200) {
      setAppTitle(res.data.theme.appName);
      document.title = res.data.theme.appName;
      setAdminHeaderColor(res.data.theme.adminHeaderColor);
      console.log("[DEBUG] Dashboard 200", res);
    }
  };
  loadFromAdminTheme();

  const logout = async () => {
    await get("/logout");

    localStorage.removeItem("accessToken");
    window.location.href = "/login";
  };

  return (
    <Grid
      style={{
        margin: 0,
        padding: 0,
        minWidth: "100%",
        minHeight: "100%",
        //height: "27vh",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Grid
        style={{
          margin: 0,
          minWidth: "100%",
          padding: theme.spacing(2),
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          //backgroundColor: "#27a737",
          backgroundColor: adminHeaderColor,
          color: "white"
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            aria-label="toggle navigation menu"
            onClick={() => setShowNavigation(!showNavigation)}
            style={{ marginRight: theme.spacing(2) }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h4">{appTitle}</Typography>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* <IconButton
            aria-label="toggle notifications"
            onClick={e => setNotificationsMenuAnchor(e.currentTarget)}
            style={{
              marginRight: theme.spacing(2)
            }}
            className={notifications.length > 0 ? "pulsating-icon" : ""}
          >
            {notifications.length > 0 ? (
              <NotificationsActiveIcon style={{ color: "white" }} />
            ) : (
              <Notifications />
            )}
          </IconButton>
          <Menu
            anchorEl={notificationsMenuAnchor}
            open={Boolean(notificationsMenuAnchor)}
            onClose={() => {
              setNotificationsMenuAnchor(null);
              setTimeout(() => {
                setNotifications([]);
              }, 100);
            }}
          >
            {notifications.length > 0 &&
              notifications.map(notification => {
                return <MenuItem>{notification}</MenuItem>;
              })}
            {notifications.length == 0 && (
              <MenuItem>No new notifications!</MenuItem>
            )}
          </Menu> */}
          <IconButton
            aria-label="toggle account"
            onClick={e => setAccountMenuAnchor(e.currentTarget)}
            style={{ marginRight: theme.spacing(2) }}
          >
            <AccountCircle />
          </IconButton>
          <Menu
            anchorEl={accountMenuAnchor}
            open={Boolean(accountMenuAnchor)}
            onClose={() => setAccountMenuAnchor(null)}
          >
            <MenuItem onClick={logout}>
              <LogoutIcon style={{ marginRight: theme.spacing(1) }} /> Logout
            </MenuItem>
            <Divider />
            <MenuItem style={{ paddingTop: "0px", paddingBottom: "0px" }}>
              <ListItemText
                primaryTypographyProps={{
                  fontSize: "0.8em",
                  fontStyle: "italic"
                }}
              >
                <span style={{ color: "rgb(39, 167, 55)" }}>
                  {env.REACT_APP_ENV}
                </span>{" "}
                v{env.REACT_APP_VERSION}
              </ListItemText>
            </MenuItem>
          </Menu>
        </div>
      </Grid>
      <Grid
        style={{
          margin: 0,
          padding: 0,
          display: "flex",
          flexDirection: "row",
          minWidth: "100%"
        }}
      >
        <Navigation
          visible={showNavigation}
          handleClose={() => setShowNavigation(false)}
        />
        <Routes>
          {JSON.parse(env.REACT_APP_API_KEYS_ENABLED) && (
            <Route path="api" element={<APIKeys />} />
          )}
          <Route path="/" element={<Home />} />
          //
          {/* <Route path="/Kiosks" element={<Kiosks />} /> */}
          <Route path="/Kiosks" element={<KioskV2 />} />
          <Route path="/ErrorLogs" element={<ErrorLogs />} />
          <Route path="/ErrorLogs/:id" element={<ErrorLogs />} />
          <Route path="/BagtagLogs" element={<BagtagLogs />} />
          <Route path="/ActivityLogs" element={<ActivityLogs />} />
          {/* <Route path="/SocketMonitor" element={<SocketMonitor />} /> */}
          <Route path="/SocketMonitorAPI" element={<SocketMonitorAPI />} />
          <Route path="/Users" element={<Users />} />
          <Route path="/Charities" element={<Charities />} />
          <Route path="/ServerSettings" element={<ServerSettings />} />
          <Route
            path="/KioskTheme"
            element={<KioskTheme reloadAdminHeader={loadFromAdminTheme} />}
          />
          <Route path="/Configuration" element={<Configuration />} />
          <Route path="/AdsSettings" element={<AdsSettings />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Grid>
    </Grid>
  );
}

export default Dashboard;
